export const communicationOptions = [
  { title: 'Hrvatski', value: 'hr' },
  { title: 'English', value: 'en' },
  { title: 'Deutsch', value: 'de' },
  { title: 'Italiano', value: 'it' },
  { title: 'Slovenščina', value: 'si' },
  { title: 'Nederlands', value: 'nl' },
]